import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.slice";
import "core-js/modules/web.dom-collections.for-each";
import { __assign, __awaiter, __generator } from "tslib";
import Vue from 'vue';
import { chooseWXPay } from '@/lib/script/pay';
export var deposit = {
  namespaced: true,
  state: {
    jackpot: {},
    history: []
  },
  mutations: {
    initHistore: function initHistore(state, count) {
      state.history = state.history.slice(0, count);
    },
    setHistory: function setHistory(state, _a) {
      var offset = _a.offset,
          list = _a.list;
      list.forEach(function (ele, key) {
        Vue.set(state.history, offset + key, __assign(__assign({}, ele), {
          count: ele.count / 100,
          balance: ele.balance / 100
        }));
      });
    },
    setJackpot: function setJackpot(state, _a) {
      var info = _a.info,
          key = _a.key; // state.jackpot.deposit = option.deposit || 0
      // state.jackpot.total_deposit = option.total_deposit || 0

      Vue.set(state.jackpot, key, {
        deposit: (info.deposit || 0) / 100,
        total_deposit: (info.total_deposit || 0) / 100,
        level_name: info.level_name || ''
      });
    }
  },
  actions: {
    getHistory: function getHistory(context, _a) {
      var offset = _a.offset,
          count = _a.count,
          forceUpdate = _a.forceUpdate,
          activityId = _a.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              if (forceUpdate) {
                this.commit('initHistore', count);
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/deposit/detail', {
                params: {
                  offset: offset,
                  count: count,
                  activity_id: activityId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                context.commit('setHistory', {
                  offset: offset,
                  list: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getInfo: function getInfo(_a, _b) {
      var commit = _a.commit;
      var activity_id = _b.activity_id,
          level_id = _b.level_id;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/deposit/jackpot', {
                params: {
                  activity_id: activity_id,
                  level_id: level_id
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setJackpot', {
                  key: [activity_id, level_id].join('_'),
                  info: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    createOrder: function createOrder(context, _a) {
      var activity_id = _a.activity_id,
          price = _a.price;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata, orderId, payResponse, payRdata, ret;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/deposit/create_order', {
                activity_id: activity_id,
                price: price
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status !== 0) {
                return [2
                /*return*/
                , {
                  status: 'error',
                  message: rdata.message
                }];
              }

              orderId = rdata.data.order_id;
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/participation/pay', {
                order_id: orderId,
                // type: rdata.data.type
                type: 'deposit'
              })];

            case 2:
              payResponse = _b.sent();
              payRdata = payResponse.data;

              if (payRdata.status !== 0) {
                return [2
                /*return*/
                , {
                  status: 'error',
                  message: payRdata.message
                }];
              }

              return [4
              /*yield*/
              , chooseWXPay(payRdata.data.params)];

            case 3:
              ret = _b.sent();
              return [2
              /*return*/
              , __assign(__assign({}, ret), {
                type: 'jsapi',
                orderId: orderId
              })];
          }
        });
      });
    }
  }
};